import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import { Modal } from "antd";
import style from "./GuaranteeSearch.module.css";
import { useState, useEffect } from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { message } from "antd";
import "./Search.css";

const { Search } = Input;

var obj = {
  test: "1112",
};

export default function Main() {
  const [modalVisible, setModalVisible] = useState(false);

  const onSearch = (value) => {
    console.log(value);
    if (value == "") return;
    axios
      .get("http://sybh.jb.zgjmdbw.com/api/guarantee/expose?order_no=" + value)
      .then(function (result) {
        console.log(result);
        if (result.data.code != 200) {
          message.warning(result.data.message);
          return;
        }
        obj = result.data.data;
        obj.statusText = "已生效";
        var isPaperGuarantee = result.data.data.order_no.indexOf("JM03") >= 0;
        obj.isPaperGuarantee = isPaperGuarantee;
        if (!isPaperGuarantee && obj.status != 4) {
          message.warning("该保函还未出函");
          return;
        }

        switch (obj.type) {
          case 1:
            obj.typeText = "投标保函";
            break;
          case 2:
            obj.typeText = "履约保函";
            break;
          case 3:
            obj.typeText = "银行保函";
            break;
          default:
            obj.typeText = "其他";
            break;
        }
        obj.termText =
          (obj.start_time ? obj.start_time.split(" ")[0] : "") +
          "-" +
          (obj.end_time ? obj.end_time.split(" ")[0] : "");
        if (isPaperGuarantee) {
          obj.typeText = obj.type + "(纸质)";
          obj.termText =
            obj.term +
            (obj.term_type == 1 ? "天" : obj.term_type == 2 ? "个月" : "年");

          if (obj.term_type == 1) {
            obj.termText = obj.term + "天";
            console.log(
              new Date(obj.issuing_time).getTime(),
              new Date(obj.issuing_time).getTime() + obj.term * 24 * 3600 * 1000
            );
            obj.end_time2 =
              new Date(obj.issuing_time).getTime() +
              obj.term * 24 * 3600 * 1000;
          }
          if (obj.term_type == 2) {
            obj.termText = obj.term + "个月";
            obj.end_time2 =
              new Date(obj.issuing_time).getTime() +
              obj.term * 31 * 24 * 3600 * 1000;
          }
          if (obj.term_type == 3) {
            obj.termText = obj.term + "年";
            obj.end_time2 =
              new Date(obj.issuing_time).getTime() +
              obj.term * 365 * 24 * 3600 * 1000;
          }

          if (new Date().getTime() > obj.end_time2) {
            obj.statusText = "已过期";
          }
        } else {
          if (new Date().getTime() > new Date(obj.end_time).getTime()) {
            obj.statusText = "已过期";
          }
        }

        setModalVisible(true);
      });
  };

  return (
    <>
      <Modal
        style={{ top: "220px" }}
        visible={modalVisible}
        footer={null}
        closable={false}
        //onCancel={() => { setModalVisible(false) }}
      >
        <div className={style.modalBox}>
          <h2>
            {" "}
            {obj.order_no} {obj.statusText}{" "}
            <CloseCircleOutlined
              onClick={() => {
                setModalVisible(false);
              }}
            />{" "}
          </h2>
          <p>
            <label>保函申请企业:</label>
            <span className={style.aa}>{obj.enterprise_name}</span>
          </p>
          <p>
            <label>保函受益人:</label>{" "}
            <span className={style.aa}>{obj.beneficiary}</span>
          </p>
          <p>
            <label>保函金额:</label> ¥{obj.amount}元
          </p>
          <p>
            <label>保函期限:</label>
            {obj.termText}
          </p>
          <p>
            <label>保函类型:</label> {obj.typeText}
          </p>
          <p>
            <label>保函出具时间{obj.isPaperGuarantee}:</label>{" "}
            {obj.issuing_time}
          </p>
          {!obj.isPaperGuarantee && (
            <a href={obj.guarantee_documents} target="_blank" rel="noreferrer">
              下载
            </a>
          )}
        </div>
      </Modal>

      <Search
        placeholder="请输入保函编号"
        allowClear
        prefix={<SearchOutlined />}
        enterButton="立即查询"
        size="large"
        onSearch={onSearch}
      />
    </>
  );
}
